<template>
  <b-alert class="error-block" show variant="danger">
    <slot name="pretext"><p v-if="pretext">{{ pretext }}</p></slot>
    <template v-for="(err, i) in (Array.isArray(err) ? err : [ err ])">
      <template v-if="typeof err === 'object'">
        <p :key="`${i}-a`" v-if="err.message">{{ err.name || 'Error' }}: {{ err.message }}<template v-if="err.code"> (<pre>{{ err.code }}</pre>)</template></p>
        <p :key="`${i}-a`" v-else>{{ `${err}` }}</p>
      </template>
      <p v-else-if="typeof err === 'string'" :key="i">Error: {{ err }}</p>
      <p v-else-if="typeof err === 'number'" :key="i">Error: #{{ err }}</p>
      <p v-else-if="typeof err === 'boolean'" :key="i">Error: {{ err === true ? 'true' : 'false' }}</p>
      <p v-else-if="err" :key="i">{{ `${err}` }}</p>
    </template>
  </b-alert>
</template>

<script>
export default {
  props: {
    err: {
      type: [ String, Number, Boolean, Error, Array, Object ],
    },
    fullPage: {
      type: Boolean,
      default: false,
    },
    pretext: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss">
.error-block {
  p {
    color: #484848;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/misc/ErrorBlock.vue